<template>
  <div class="dashboard">
    <div class="mobile-message">
      <h3>Until we can run flutter code on device this won't work on mobile :)</h3>
      <p>AppSkeletons generates Flutter projects so desktop is best.</p>
    </div>
    <div class="dashboard-content">
      <h3>Your Apps</h3>
      <simplebar class="projects-container">
        <div class="projects">
          <h2 class="fetching-info" v-show="isFecthingApps && !hasError">Fetching app history ...</h2>
          <h2
            class="fetching-info"
            v-show="hasError"
          >An error occured while fetching your app history. Refresh again later.</h2>
          <h2
            class="fetching-info"
            v-show="!isFecthingApps && !hasApps && !hasError"
          >You have no apps yet. Create one.</h2>
          <div
            v-for="(app, index) in apps"
            v-bind:key="index"
            v-show="!isFecthingApps && hasApps && !hasError"
            @click="selectApp(app)"
            :class="{'app-active' : isAppSelected(app), 'project-item' : !isAppSelected(app)}"
          >
            <img class="technology-image" src="../assets/images/technologies/flutter-logo.png">
            <p class="application-name">{{ app.appName }}</p>
            <p class="project-id">{{app.projectId}}</p>
            <p class="body-text">{{ mapArchitectureToTechName(app.templateName) }}</p>
          </div>
        </div>
        <button class="bottom-right" @click="navigateToTechnologies()">Create project</button>
      </simplebar>
    </div>
    <transition name="details-drawer">
      <simplebar v-if="hasSelectedApp" class="app-details">
       
        <div class="app-details-content">
          <div class="close-button-wrapper" @click="deselectView()">
            <img class="close-button" src="../assets/images/close-button.svg">
          </div>
          <h3>App details</h3>
          <p class="body-title">Name</p>
          <p class="body">{{selectedApp.appName}}</p>
          <p class="body-title">Project Id</p>
          <p class="body">{{selectedApp.projectId}}</p>
          <p class="body-title">PackageName</p>
          <p class="body">{{selectedApp.packageName}}</p>
          <p class="body-title">Framework</p>
          <p class="body">{{getSelectedTechnologyName}}</p>
          <p class="body-title">Architecture</p>
          <p class="body">{{getSelectedArchitectureName}}</p>
          <p class="body-title">Views</p>
          <ul class="all-views-container">
            <li
              class="view-container"
              v-for="(view, index) in selectedApp.views"
              v-bind:key="index"
            >
              <p class="view-title">{{view.name}}</p>
              <p class="view-body">{{view.type}}</p>
            </li>
          </ul>
          <div class="detail-buttons">
            <div class="delete-button" @click="promptRemoveProject()">Delete App</div>
            <div class="generate-button" @click="viewSelectedProject()">View App</div>
          </div>
        </div>
      </simplebar>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import simplebar from "simplebar-vue";

export default {
  name: "Dashboard",
  components: {
    simplebar
  },
  mounted() {
    this.clearSelections();
    this.UPDATE_NAVIGATION_BAR_STATE(1);
    this.setFooterState(1);
  },
  computed: {
    ...mapState(["apps", "selectedApp"]),
    ...mapGetters([
      "hasSelectedApp", 
      "getSelectedArchitectureName", 
      "getSelectedTechnologyName", 
      "isAppSelected"]),
    isFecthingApps() {
      return this.apps == "fetching";
    },
    hasApps() {
      return this.apps.length > 0;
    },
    hasError() {
      return this.apps == "error";
    }
  },
  methods: {
    promptRemoveProject() {
      this.$modal.show("info-modal", {
        title: "Are you sure?",
        message: `Do you want to delete your application? This is not reversable.`,
        confirmButton: "Yes, delete",
        cancelButton: "Cancel",
        positiveCallback: () => {
          this.removeSelectedProject();
        }
      });
    },
    removeSelectedProject() {
      this.removeAppForUser({appId: this.selectedApp.appId, appIndex: this.selectedAppIndex});
      this.clearSelections();
    },
    deselectView() {
      this.clearSelections();
    },
    viewSelectedProject() {
        this.$router.push("app-details");
    },
    getFrameworkFromTemplateName(templateName) {
      switch (templateName) {
        case "scoped_model_model_per_view":
          return "Flutter";
        default:
          return "";
      }
    },
    getArchitectureFromTemplateName(templateName) {
      switch (templateName) {
        case "scoped_model_model_per_view":
          return "ScopedModel";
        default:
          return "";
      }
    },
    mapArchitectureToTechName(architecture) {
      if (architecture == "scoped_model_model_per_view") {
        return "Flutter and ScopedModel";
      }

      if (architecture == "bloc_arc") {
        return "Flutter and BLoC";
      }
    },
    navigateToTechnologies() {
      this.$router.push("select-technology");
    },
    selectApp(app) {
      this.setSelectedApp(app);
    },
    ...mapActions([
      "removeAppForUser",
      "setSelectedApp",
      "clearSelections",
      "setFooterState"
    ]),
    ...mapMutations(["UPDATE_NAVIGATION_BAR_STATE"])
  },
  data() {
    return {
      selectedAppIndex: -1
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

.mobile-message {
  display: none;
}

.dashboard-content {
  display: block;
}

.app-details-content {
  position: relative;
}

.detail-buttons {
  margin-top: 30px;
}

.delete-button,
.generate-button {
  padding: 10px;
  border-radius: 5px;
  width: fit-content;
  transition: 0.3s;
  cursor: pointer;
}

.delete-button {
  border: solid $validation-message-color 1px;
  color: $validation-message-color;
  display: inline-block;
}

.delete-button:hover {
  background-color: $light-grey-color;
}

.generate-button:hover {
  background-color: $primary-color-light;
}

.view-app-button {
  color: $primary-color;
  background-color: white;
  display: inline-block;
}

.generate-button {
  background-color: $primary-color;
  float: right;
}

h2 {
  width: 600px;
}

.dashboard {
  position: relative;
  overflow: hidden;
}

.projects-container {
  margin-top: 50px;
  height: calc(100% - 100px);
}

.app-details {
  position: absolute;
  right: 0;
  top: 10px;
  height: 100%;
  width: 400px;
  background: $background-color;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  box-sizing: border-box;
  padding: 30px;

  .body-title {
    margin-top: 30px;
  }
}

.projects {
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
  grid-row-gap: 15px;
}

$project-item-width: 180px;
$project-item-height: 230px;

.application-name {
  margin-top: 10px;
}

.project-id {
  font-size: 9px;
  font-weight: 400;
}

.body-text {
  margin-top: 15px;
  font-size: 12px;
}

.project-item,
.app-active {
  position: relative;
  width: $project-item-width;
  height: $project-item-height;
  background-color: $info-container-color;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px;
  transition: 0.3s;
  cursor: pointer;
}

.project-item:hover,
.app-active:hover {
  background-color: $light-grey-color;
}

.project-item {
  border: solid 3px transparent;
}

.app-active {
  border: solid 3px $primary-color;
}

$close-button-size: 35px;

.close-button-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;

  width: $close-button-size;
  height: $close-button-size;
}

$close-button-image-size: 10px;

.close-button {
  width: $close-button-image-size;
  height: $close-button-image-size;
}

.technology-image {
  padding-right: 40px;
  box-sizing: border-box;
  object-fit: contain;
  width: $project-item-width;
  height: $project-item-height / 2;
  // background: red;
}

.all-views-container {
  margin: 0;
  padding: 0;
}

.view-container {
  background-color: $dark-grey-color;
  height: 50px;
  width: fit-content;
  border-radius: 5px;
  display: inline-block;
  margin-right: 5px;
  margin-top: 5px;
  padding: 5px 8px;
}

.view-title,
.view-body {
  margin: 0;
  padding: 0;
  width: fit-content;
  font-size: 0.8em;
}

.view-title {
  font-weight: 700;
}

.details-drawer-enter-active {
  animation: coming 0.3s;
  opacity: 0;
}

.details-drawer-leave-active {
  animation: going 0.3s;
}

@keyframes going {
  from {
    transform: translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateX(30%);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(30%);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

// max width means smaller
@media only screen and (max-width: 641px) {
  button {
    display: none;
  }

  .dashboard-content {
    display: none;
  }

  .mobile-message {
    display: block;
    display: grid;
    width: 100%;
    height: fit-content;
    background: $light-grey-color;
    border-radius: 5px;
    padding: 15px;

    grid-template-rows: 250px 80px;
    grid-template-areas:
      "title"
      "message";

    h3 {
      grid-area: title;
      font-size: 20px;
      margin: 10px;
      text-align: center;
    }

    p {
      grid-area: message;
      text-align: center;
    }
  }
}

@media only screen and (max-width: 320px) {
}
</style>
